import Cookies from 'js-cookie'
import { mapGetters } from 'vuex'
import { setLocal, getLocal } from '@/common/js/api'
import { isArray, setLocalInfo, setStoreName, camelcase } from '@/common/js/utils'
import { getAccountBalance } from '@/api/convert.model'

export default {
  computed: {
    ...mapGetters('Convert', ['currentRoute'])
  },
  data () {
    return {
      pageIndex: 1,
      pageSize: parseInt(getLocal('PAGESIZE')) || 10,
      total: 0,
      balancing: false, // 账户余额状态
      balance: '',
      collapsible: null // 展开过滤器
    }
  },
  methods: {
    sortTable (params) {
      const { sort, order } = params
      this.sort = sort
      this.order = order
      this.pageIndex = 1
      this.getData()
    },
    setLocalPage (size) {
      setLocal('PAGESIZE', size)
    },
    searchFilterData (params) {
      this.pageIndex = 1
      this.getData(params)
      this.mainVal && this.getBalance(params)
    },
    filterData (params) {
      this.pageIndex = 1
      this.getData(params)
      this.mainVal && this.getBalance(params)
    },
    // 自定义列
    selectColumn (params) {
      const columns = params.sort((a, b) => (a._time || 0) - (b._time || 0))
      this.$set(this, 'columns', columns)
      this.modalColumn = false
    },
    headerDragend ({ n, column }) {
      const index = this.columns.findIndex(ret => ret.key === column.property)
      index > -1 && this.$set(this.columns[index], 'width', n)
    },
    getCustomStorage (name) {
      const account = Cookies.get('ch_op_id')
      const storage = getLocal(name)
      if (storage && isArray(storage[account])) return storage[account]
      else return []
    },
    setCustomStorage (name, list) {
      const account = Cookies.get('ch_op_id')
      let storage = getLocal(name)
      if (!storage) storage = {}
      storage[account] = list
      setLocal(name, storage)
    },
    getBalance ({ adAccountId }) {
      this.balancing = true
      getAccountBalance({
        ad_account_id: adAccountId,
        media_id: this.mediaVal
      }).then(data => {
        this.balancing = false
        typeof data === 'number' && (this.balance = data)
      })
    },
    openNewEntry () {
      const account = Cookies.get('ch_user_name')
      const id = Cookies.get('ch_op_id')
      const storeName = setStoreName(this.mediaVal)

      setLocalInfo(id, account, String(this.mediaVal))
      this.$store.commit(`${camelcase(storeName)}/setMedia`, this.mediaVal)
      this.$store.commit(`${camelcase(storeName)}/setOpId`, id)
      this.$store.commit(`${camelcase(storeName)}/setAdmin`, account)
      window.open(`/create/${storeName}/group`, '_blank')
    }
  }
}
